<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    created() {},
    data() {
      return {};
    }
  };
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
  @import './assets/scss/base.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: px2rem(750);
  }

</style>



// WEBPACK FOOTER //
// App.vue?7be0b751